module.exports = __webpack_public_path__ + "static/media/icon-camel-filled.9889f40b.svg";